import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'ホーム', href: '/' },
  { label: 'サービス', href: '/services' },
  { label: 'プラン', href: '/plans' },
  { label: 'お問い合わせ', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleNavigateTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled ? 'bg-white shadow-sm' : 'bg-white shadow-sm'
        }`}
      >
        <div className="w-full px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/7e733562-7236-46f6-8831-a9c8bff9fb4c.png"
              alt="株式会社ＡＬＡ ロゴ"
              className="h-8 md:h-10 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const active = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={handleNavigateTop}
                  className={`text-sm font-medium tracking-wider transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                    active
                      ? 'text-[#C8501A]'
                      : 'text-[#0A0E1A] hover:text-[#C8501A]'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/contact"
              onClick={handleNavigateTop}
              className="ml-4 px-5 py-2 bg-[#0A0E1A] text-white text-sm font-medium rounded-full hover:bg-[#C8501A] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              無料相談
            </Link>
          </nav>

          {/* Mobile hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニューを開く"
          >
            <span className={`block w-6 h-0.5 bg-[#0A0E1A] transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-0.5 bg-[#0A0E1A] transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-0.5 bg-[#0A0E1A] transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>

        {/* Mobile menu */}
        <div
          className={`md:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ${
            menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="flex flex-col px-6 py-4 gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={handleNavigateTop}
                className="text-sm font-medium text-[#0A0E1A] hover:text-[#C8501A] transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={handleNavigateTop}
              className="mt-2 px-5 py-2 bg-[#0A0E1A] text-white text-sm font-medium rounded-full text-center hover:bg-[#C8501A] transition-colors cursor-pointer whitespace-nowrap"
            >
              無料相談
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
}
